const m11UDPsectionCodesValueSet = [
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C222769",
    "display": "ICH M11 Protocol Section Title Page"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218514",
    "display": "ICH M11 Protocol Section 1 PROTOCOL SUMMARY"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218515",
    "display": "ICH M11 Protocol Section 1.1 Protocol Synopsis"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218516",
    "display": "ICH M11 Protocol Section 1.1.1 Primary and Secondary Objectives and Estimands"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218517",
    "display": "ICH M11 Protocol Section 1.1.2 Overall Design"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218518",
    "display": "ICH M11 Protocol Section 1.2 Trial Schema"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218519",
    "display": "ICH M11 Protocol Section 1.3 Schedule of Activities"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218520",
    "display": "ICH M11 Protocol Section 2 INTRODUCTION"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218521",
    "display": "ICH M11 Protocol Section 2.1 Purpose of Trial"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218522",
    "display": "ICH M11 Protocol Section 2.2 Assessment of Risks and Benefits"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218523",
    "display": "ICH M11 Protocol Section 2.2.1 Risk Summary and Mitigation Strategy"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218524",
    "display": "ICH M11 Protocol Section 2.2.2 Benefit Summary"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218525",
    "display": "ICH M11 Protocol Section 2.2.3 Overall Risk-Benefit Assessment"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218526",
    "display": "ICH M11 Protocol Section 3 TRIAL OBJECTIVES AND ASSOCIATED ESTIMANDS"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218527",
    "display": "ICH M11 Protocol Section 3.1 Primary Objective(s) and Associated Estimand(s)"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218528",
    "display": "ICH M11 Protocol Section 3.1.1 Primary Objective"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218529",
    "display": "ICH M11 Protocol Section 3.2 Secondary Objective(s) and Associated Estimand(s)"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218530",
    "display": "ICH M11 Protocol Section 3.2.1 Secondary Objective"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218531",
    "display": "ICH M11 Protocol Section 3.3 Exploratory Objective(s)"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218532",
    "display": "ICH M11 Protocol Section 3.3.1 Exploratory Objective"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218533",
    "display": "ICH M11 Protocol Section 4 TRIAL DESIGN"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218534",
    "display": "ICH M11 Protocol Section 4.1 Description of Trial Design"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218535",
    "display": "ICH M11 Protocol Section 4.1.1 Stakeholder Input into Design"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218536",
    "display": "ICH M11 Protocol Section 4.2 Rationale for Trial Design"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218537",
    "display": "ICH M11 Protocol Section 4.2.1 Rationale for Estimand(s)"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218538",
    "display": "ICH M11 Protocol Section 4.2.2 Rationale for Intervention Model"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218539",
    "display": "ICH M11 Protocol Section 4.2.3 Rationale for Control Type"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218540",
    "display": "ICH M11 Protocol Section 4.2.4 Rationale for Trial Duration"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218541",
    "display": "ICH M11 Protocol Section 4.2.5 Rationale for Adaptive or Novel Trial Design"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218542",
    "display": "ICH M11 Protocol Section 4.2.6 Rationale for Interim Analysis"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218543",
    "display": "ICH M11 Protocol Section 4.2.7 Rationale for Other Trial Design Aspects"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218544",
    "display": "ICH M11 Protocol Section 4.3 Trial Stopping Rules"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218545",
    "display": "ICH M11 Protocol Section 4.4 Start of Trial and End of Trial"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218546",
    "display": "ICH M11 Protocol Section 4.5 Access to Trial Intervention After End of Trial"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218547",
    "display": "ICH M11 Protocol Section 5 TRIAL POPULATION"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218548",
    "display": "ICH M11 Protocol Section 5.1 Description of Trial Population and Rationale"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218549",
    "display": "ICH M11 Protocol Section 5.2 Inclusion Criteria"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218550",
    "display": "ICH M11 Protocol Section 5.3 Exclusion Criteria"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218551",
    "display": "ICH M11 Protocol Section 5.4 Contraception"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218552",
    "display": "ICH M11 Protocol Section 5.4.1 Definitions Related to Childbearing Potential"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218553",
    "display": "ICH M11 Protocol Section 5.4.2 Contraception Requirements"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218554",
    "display": "ICH M11 Protocol Section 5.5 Lifestyle Restrictions"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218555",
    "display": "ICH M11 Protocol Section 5.5.1 Meals and Dietary Restrictions"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218556",
    "display": "ICH M11 Protocol Section 5.5.2 Caffeine, Alcohol, Tobacco, and Other Restrictions"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218557",
    "display": "ICH M11 Protocol Section 5.5.3 Physical Activity Restrictions"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218558",
    "display": "ICH M11 Protocol Section 5.5.4 Other Activity Restrictions"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218559",
    "display": "ICH M11 Protocol Section 5.6 Screen Failure and Rescreening"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218560",
    "display": "ICH M11 Protocol Section 6 TRIAL INTERVENTION AND CONCOMITANT THERAPY"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218561",
    "display": "ICH M11 Protocol Section 6.1 Description of Investigational Trial Intervention"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218562",
    "display": "ICH M11 Protocol Section 6.2 Rationale for Investigational Trial Intervention Dose and Regimen"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218563",
    "display": "ICH M11 Protocol Section 6.3 Investigational Trial Intervention Administration"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218564",
    "display": "ICH M11 Protocol Section 6.4 Investigational Trial Intervention Dose Modification"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218565",
    "display": "ICH M11 Protocol Section 6.5 Management of Investigational Trial Intervention Overdose"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218566",
    "display": "ICH M11 Protocol Section 6.6 Preparation, Storage, Handling and Accountability of Investigational Trial Intervention"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218567",
    "display": "ICH M11 Protocol Section 6.6.1 Preparation of Investigational Trial Intervention"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218568",
    "display": "ICH M11 Protocol Section 6.6.2 Storage and Handling of Investigational Trial Intervention"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218569",
    "display": "ICH M11 Protocol Section 6.6.3 Accountability of Investigational Trial Intervention"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218570",
    "display": "ICH M11 Protocol Section 6.7 Investigational Trial Intervention Assignment, Randomisation and Blinding"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218571",
    "display": "ICH M11 Protocol Section 6.7.1 Participant Assignment to Investigational Trial Intervention"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218572",
    "display": "ICH M11 Protocol Section 6.7.2 Randomisation"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218573",
    "display": "ICH M11 Protocol Section 6.7.3 Measures to Maintain Blinding"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218574",
    "display": "ICH M11 Protocol Section 6.7.4 Emergency Unblinding at the Site"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218575",
    "display": "ICH M11 Protocol Section 6.8 Investigational Trial Intervention Adherence"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218576",
    "display": "ICH M11 Protocol Section 6.9 Description of Noninvestigational Trial Intervention"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218577",
    "display": "ICH M11 Protocol Section 6.9.1 Background Trial Intervention"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218578",
    "display": "ICH M11 Protocol Section 6.9.2 Rescue Therapy"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218579",
    "display": "ICH M11 Protocol Section 6.9.3 Other Noninvestigational Trial Intervention"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218580",
    "display": "ICH M11 Protocol Section 6.10 Concomitant Therapy"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218581",
    "display": "ICH M11 Protocol Section 6.10.1 Prohibited Concomitant Therapy"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218582",
    "display": "ICH M11 Protocol Section 6.10.2 Permitted Concomitant Therapy"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218583",
    "display": "ICH M11 Protocol Section 7 PARTICIPANT DISCONTINUATION OF TRIAL INTERVENTION AND DISCONTINUATION OR WITHDRAWAL FROM TRIAL"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218584",
    "display": "ICH M11 Protocol Section 7.1 Discontinuation of Trial Intervention for Individual Participants"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218585",
    "display": "ICH M11 Protocol Section 7.1.1 Permanent Discontinuation of Trial Intervention"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218586",
    "display": "ICH M11 Protocol Section 7.1.2 Temporary Discontinuation of Trial Intervention"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218587",
    "display": "ICH M11 Protocol Section 7.1.3 Rechallenge"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218588",
    "display": "ICH M11 Protocol Section 7.2 Participant Discontinuation or Withdrawal from the Trial"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218589",
    "display": "ICH M11 Protocol Section 7.3 Management of Loss to Follow-Up"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218590",
    "display": "ICH M11 Protocol Section 8 TRIAL ASSESSMENTS AND PROCEDURES"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218591",
    "display": "ICH M11 Protocol Section 8.1 Trial Assessments and Procedures Considerations"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218592",
    "display": "ICH M11 Protocol Section 8.2 Screening/Baseline Assessments and Procedures"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218593",
    "display": "ICH M11 Protocol Section 8.3 Efficacy Assessments and Procedures"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218594",
    "display": "ICH M11 Protocol Section 8.4 Safety Assessments and Procedures"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218595",
    "display": "ICH M11 Protocol Section 8.4.1 Physical Examination"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218596",
    "display": "ICH M11 Protocol Section 8.4.2 Vital Signs"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218597",
    "display": "ICH M11 Protocol Section 8.4.3 Electrocardiograms"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218598",
    "display": "ICH M11 Protocol Section 8.4.4 Clinical Laboratory Assessments"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218599",
    "display": "ICH M11 Protocol Section 8.4.5 Pregnancy Testing"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218600",
    "display": "ICH M11 Protocol Section 8.4.6 Suicidal Ideation and Behaviour Risk Monitoring"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218601",
    "display": "ICH M11 Protocol Section 8.5 Pharmacokinetics"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218602",
    "display": "ICH M11 Protocol Section 8.6 Biomarkers"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218603",
    "display": "ICH M11 Protocol Section 8.6.1 Genetics, Genomics, Pharmacogenetics and Pharmacogenomics"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218604",
    "display": "ICH M11 Protocol Section 8.6.2 Pharmacodynamic Biomarkers"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218605",
    "display": "ICH M11 Protocol Section 8.6.3 Other Biomarkers"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218606",
    "display": "ICH M11 Protocol Section 8.7 Immunogenicity Assessments"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218607",
    "display": "ICH M11 Protocol Section 8.8 Medical Resource Utilisation and Health Economics"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218608",
    "display": "ICH M11 Protocol Section 9 ADVERSE EVENTS, SERIOUS ADVERSE EVENTS, PRODUCT COMPLAINTS, PREGNANCY AND POSTPARTUM INFORMATION, AND SPECIAL SAFETY SITUATIONS"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218609",
    "display": "ICH M11 Protocol Section 9.1 Definitions"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218610",
    "display": "ICH M11 Protocol Section 9.1.1 Definitions of Adverse Events"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218611",
    "display": "ICH M11 Protocol Section 9.1.2 Definitions of Serious Adverse Events"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218612",
    "display": "ICH M11 Protocol Section 9.1.3 Definitions of Product Complaints"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218613",
    "display": "ICH M11 Protocol Section 9.1.3.1 Definitions of Medical Device Product Complaints"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218614",
    "display": "ICH M11 Protocol Section 9.2 Timing and Procedures for Collection and Reporting"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218615",
    "display": "ICH M11 Protocol Section 9.2.1 Timing"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218616",
    "display": "ICH M11 Protocol Section 9.2.2 Collection Procedures"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218617",
    "display": "ICH M11 Protocol Section 9.2.3 Reporting"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218618",
    "display": "ICH M11 Protocol Section 9.2.3.1 Regulatory Reporting Requirements"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218619",
    "display": "ICH M11 Protocol Section 9.2.4 Adverse Events of Special Interest"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218620",
    "display": "ICH M11 Protocol Section 9.2.5 Disease-related Events or Outcomes Not Qualifying as AEs or SAEs"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218621",
    "display": "ICH M11 Protocol Section 9.3 Pregnancy and Postpartum Information"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218622",
    "display": "ICH M11 Protocol Section 9.3.1 Participants Who Become Pregnant During the Trial"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218623",
    "display": "ICH M11 Protocol Section 9.3.2 Participants Whose Partners Become Pregnant During the Trial"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218624",
    "display": "ICH M11 Protocol Section 9.4 Special Safety Situations"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218625",
    "display": "ICH M11 Protocol Section 10 STATISTICAL CONSIDERATIONS"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218626",
    "display": "ICH M11 Protocol Section 10.1 General Considerations"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218627",
    "display": "ICH M11 Protocol Section 10.2 Analysis Sets"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218628",
    "display": "ICH M11 Protocol Section 10.3 Analyses of Demographics and Other Baseline Variables"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218629",
    "display": "ICH M11 Protocol Section 10.4 Analyses Associated with the Primary Objective(s)"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218630",
    "display": "ICH M11 Protocol Section 10.4.1 Primary Objective"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218631",
    "display": "ICH M11 Protocol Section 10.4.1.1 Statistical Analysis Method"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218632",
    "display": "ICH M11 Protocol Section 10.4.1.2 Handling of Data in Relation to Primary Estimand(s)"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218633",
    "display": "ICH M11 Protocol Section 10.4.1.3 Handling of Missing Data in Relation to Primary Estimand(s)"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218634",
    "display": "ICH M11 Protocol Section 10.4.1.4 Sensitivity Analysis"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218635",
    "display": "ICH M11 Protocol Section 10.4.1.5 Supplementary Analysis"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218636",
    "display": "ICH M11 Protocol Section 10.5 Analyses Associated with the Secondary Objective(s)"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218637",
    "display": "ICH M11 Protocol Section 10.5.1 Secondary Objective"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218638",
    "display": "ICH M11 Protocol Section 10.5.1.1 Statistical Analysis Method"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218639",
    "display": "ICH M11 Protocol Section 10.5.1.2 Handling of Data in Relation to Secondary Estimand(s)"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218640",
    "display": "ICH M11 Protocol Section 10.5.1.3 Handling of Missing Data in Relation to Secondary Estimand(s)"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218641",
    "display": "ICH M11 Protocol Section 10.5.1.4 Sensitivity Analysis"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218642",
    "display": "ICH M11 Protocol Section 10.5.1.5 Supplementary Analysis"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218643",
    "display": "ICH M11 Protocol Section 10.6 Analyses Associated with the Exploratory Objective(s)"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218644",
    "display": "ICH M11 Protocol Section 10.7 Safety Analyses"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218645",
    "display": "ICH M11 Protocol Section 10.8 Other Analyses"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218646",
    "display": "ICH M11 Protocol Section 10.9 Interim Analyses"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218647",
    "display": "ICH M11 Protocol Section 10.10 Multiplicity Adjustments"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218648",
    "display": "ICH M11 Protocol Section 10.11 Sample Size Determination"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218649",
    "display": "ICH M11 Protocol Section 11 TRIAL OVERSIGHT AND OTHER GENERAL CONSIDERATIONS"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218650",
    "display": "ICH M11 Protocol Section 11.1 Regulatory and Ethical Considerations"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218651",
    "display": "ICH M11 Protocol Section 11.2 Trial Oversight"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218652",
    "display": "ICH M11 Protocol Section 11.2.1 Investigator Responsibilities"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218653",
    "display": "ICH M11 Protocol Section 11.2.2 Sponsor Responsibilities"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218654",
    "display": "ICH M11 Protocol Section 11.3 Informed Consent Process"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218655",
    "display": "ICH M11 Protocol Section 11.3.1 Informed Consent for Rescreening"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218656",
    "display": "ICH M11 Protocol Section 11.3.2 Informed Consent for Use of Remaining Samples in Exploratory Research"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218657",
    "display": "ICH M11 Protocol Section 11.4 Committees"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218658",
    "display": "ICH M11 Protocol Section 11.5 Insurance and Indemnity"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218659",
    "display": "ICH M11 Protocol Section 11.6 Risk-Based Quality Management"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218660",
    "display": "ICH M11 Protocol Section 11.7 Data Governance"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218661",
    "display": "ICH M11 Protocol Section 11.8 Data Protection"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218662",
    "display": "ICH M11 Protocol Section 11.9 Source Records"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218663",
    "display": "ICH M11 Protocol Section 11.10 Protocol Deviations"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218664",
    "display": "ICH M11 Protocol Section 11.11 Early Site Closure"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218665",
    "display": "ICH M11 Protocol Section 11.12 Data Dissemination"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218666",
    "display": "ICH M11 Protocol Section 12 APPENDIX: SUPPORTING DETAILS"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218667",
    "display": "ICH M11 Protocol Section 12.1 Clinical Laboratory Tests"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218668",
    "display": "ICH M11 Protocol Section 12.2 Country/Region-Specific Differences"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218669",
    "display": "ICH M11 Protocol Section 12.3 Prior Protocol Amendment(s)"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218670",
    "display": "ICH M11 Protocol Section 13 APPENDIX: GLOSSARY OF TERMS AND ABBREVIATIONS"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C218671",
    "display": "ICH M11 Protocol Section 14 APPENDIX: REFERENCES"
  }
];

const m11LimitedSectionCodesValueSet = [
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C217342",
    "display": "ICH M11 Protocol Section 1 PROTOCOL SUMMARY"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C217343",
    "display": "ICH M11 Protocol Section 2 INTRODUCTION"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C217344",
    "display": "ICH M11 Protocol Section 3 TRIAL OBJECTIVES AND ASSOCIATED ESTIMANDS"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C217345",
    "display": "ICH M11 Protocol Section 4 TRIAL DESIGN"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C217346",
    "display": "ICH M11 Protocol Section 5 TRIAL POPULATION"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C217347",
    "display": "ICH M11 Protocol Section 6 TRIAL INTERVENTION AND CONCOMITANT THERAPY"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C217348",
    "display": "ICH M11 Protocol Section 7 PARTICIPANT DISCONTINUATION OF TRIAL INTERVENTION AND DISCONTINUATION OR WITHDRAWAL FROM TRIAL"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C217349",
    "display": "ICH M11 Protocol Section 8 TRIAL ASSESSMENTS AND PROCEDURES"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C217350",
    "display": "ICH M11 Protocol Section 9 ADVERSE EVENTS, SERIOUS ADVERSE EVENTS, PRODUCT COMPLAINTS, PREGNANCY AND POSTPARTUM INFORMATION, AND SPECIAL SAFETY SITUATIONS"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C217351",
    "display": "ICH M11 Protocol Section 10 STATISTICAL CONSIDERATIONS"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C217352",
    "display": "ICH M11 Protocol Section 11 TRIAL OVERSIGHT AND OTHER GENERAL CONSIDERATIONS"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C217353",
    "display": "ICH M11 Protocol Section 12 APPENDIX: SUPPORTING DETAILS"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C217354",
    "display": "ICH M11 Protocol Section 13 APPENDIX: GLOSSARY OF TERMS AND ABBREVIATIONS"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C217355",
    "display": "ICH M11 Protocol Section 14 APPENDIX: REFERENCES"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C217356",
    "display": "ICH M11 Protocol Section Title Page"
  },
  {
    "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
    "code": "C217357",
    "display": "ICH M11 Protocol Section Amendment Details"
  }
];

export default m11LimitedSectionCodesValueSet;
export { m11UDPsectionCodesValueSet };